// extracted by mini-css-extract-plugin
module.exports = {"Content":"Footer_Content__2YaHL","MenuItem":"Footer_MenuItem__2ohT4"};